import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import CountdownOverlay from './components/CountdownOverlay';

function App() {
  const [showCountdown, setShowCountdown] = useState(() => {
    // Check if countdown has already ended
    return localStorage.getItem('countdownEnded') !== 'true';
  });

  const handleCountdownEnd = () => {
    setShowCountdown(false);
  };

  return (
    <div className="App">
      {showCountdown && <CountdownOverlay onCountdownEnd={handleCountdownEnd} />}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;